App.SettingsStaffNewController = Em.Controller.extend
  availableRestaurants: [
    {name: 'Рис на Садовой', id: 1}
  ,
    {name: 'Рис на Садовой', id: 2}
  ,
    {name: 'Рис на Садовой', id: 3}
  ]

  selectedRestaurants: []